import CommercialServicePage from '@/components/commercial-service-page'
import { getLegacyServicePage } from '@/constants/legacy-service-pages'
import WorkGallery from '@/components/service/email-work-gallery'

export default function ServiceRoute() {
  const page = getLegacyServicePage('email-marketing')
  return (
    <>
      <CommercialServicePage page={page} showcase={<WorkGallery />} />
    </>
  )
}

ServiceRoute.serviceTheme = 'blue'
ServiceRoute.usesServiceTemplate = true
